module.exports = __webpack_public_path__ + "70776c79cc20b3e7bd3931cdb3532c60.pdf";